/* global app */
/* global event */
/* global gui, navigator */
app.controller('overviewCtrl', ['$rootScope', '$scope', '$http', '$compile', 'NetworkService', 'AtlasDialog', 'AtlasNotification', function($rootScope, $scope, $http, $compile, NetworkService, AtlasDialog, AtlasNotification) {

    $scope.canShare = navigator.share;
    $scope.hint = {};
    $scope.hint.content ="Hinweis";
    
    $scope.gui = {};
    $scope.gui.showHintSaveButton = false;
    
    $scope.openSubscriptionDialog = function(id){
        AtlasDialog.simpleTextLineDialog(function(email){
            var data = {
                announcementId: id,
                email: email
            }
            NetworkService.callOperation("subscribe", data, function(response){
                AtlasNotification.info("Die Registrierung war Erfolgreich. Du bekommst eine E-Mail sobald die Volunteer-Suche losgeht!");
            }) 
        }, function(){
            
        }, {
            fielDescription:"E-Mail", 
            text:"Deine E-Mail Adresse:", 
            yesButton:"Anmelden",
            dsgvoMark:true
        });
    }
    
    $scope.shareEvent = function(eventId, eventName) {
        if (navigator.share) {
            var url = window.location.origin;
            navigator.share({
                    title: eventName,
                    text: eventName+' - Die Anmeldung für die Volunteers is offen!\n',
                    url: url+"/manager/"+eventId,
                })
                .then(function() {
                    console.log('Successful share')
                })
                .catch(function(error) {
                    console.log('Error sharing', error)
                });
        }
    }
    
    $scope.archiveEvent = function(eventId){
        
        NetworkService.callOperation("archiveEvent/"+eventId, {}, function(response){
            AtlasNotification.info("Das Event wurde erfolgreich Archiviert.");
        }) 
    }

}])
